// Copyright 2026. WebPros International GmbH. All rights reserved.

import * as React from 'react';
import { Popover } from '@plesk/ui-library';
import { Button } from 'admin/common/components/Button/Button';
import {
    Container,
    PopoverContainer,
} from 'common/components/PopoverList/Styles';

export interface IPopoverListProps<T> {
    items: T[];
    render: (item: T, index: number) => React.ReactNode | string;
    keyExtractor: (item: T) => string;
}

export const PopoverList = <T,>({
    items,
    render,
    keyExtractor,
}: IPopoverListProps<T>) => {
    if (items.length === 0) {
        return null;
    }

    return (
        <Container>
            {render(items[0], 0)}
            {items.length > 1 &&
                (
                    <Popover
                        placement="bottom-left"
                        target={
                            <Button ghost={true}>
                                +{items.length - 1}
                            </Button>
                        }
                    >
                        <PopoverContainer>
                            {items.slice(1).map((item, index) => (
                                <div key={keyExtractor(item)}>{render(item, index + 1)}</div>
                            ))}
                        </PopoverContainer>
                    </Popover>
                )
            }
        </Container>
    );
};

export default PopoverList;
